import { render, staticRenderFns } from "./editmodelinfo.vue?vue&type=template&id=63e5ac7c"
import script from "./editmodelinfo.vue?vue&type=script&lang=js"
export * from "./editmodelinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports